import { Store } from '@personnel/domain/entities/Store';
import { createStoreHttpClient } from '@personnel/infrastructure/api/StoreHttpClient';
import { transformApiStoreToEntity } from '@personnel/infrastructure/mappers/StoreApiMapper';
import { AxiosInstance } from 'axios';
import type { IStoreApiPort } from '@personnel/application/ports/IStoreApiPort';

export const createStoreApiRepository = (props: { httpClient: AxiosInstance }): IStoreApiPort => {
  const storeHttpClient = createStoreHttpClient(props);

  const getStores = async (request: { organizationUuid?: string; storeUuid?: string }): Promise<Store[]> => {
    const response = await storeHttpClient.getStores(request);
    return response.data.map(transformApiStoreToEntity);
  };

  return {
    getStores,
  };
};
